"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const CodeDone = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 24,
  height: 24,
  viewBox: "-1 0 24 24"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M21.798 16L23 17.192 18.15 22 15 18.877l1.202-1.192 1.948 1.933L21.798 16zM13.924 2L18 5.96v8.21c-2.52.412-4.444 2.537-4.444 5.104 0 .606.112 1.185.309 1.726H3.778C2.798 21 2 20.225 2 19.273V3.727C2 2.775 2.797 2 3.778 2h10.146zm-1.518 8.892l-1.257 1.221 2.039 1.98-2.039 1.98 1.257 1.222 3.295-3.202-3.295-3.201zm-4.812 0l-3.295 3.202 3.295 3.201 1.257-1.221-2.039-1.98 2.039-1.98-1.257-1.222zm5.073-8.028v4.318h4.444l-4.444-4.318z",
  fill: "none",
  fillRule: "evenodd"
}));
var _default = exports.default = CodeDone;